<template>
  <b-container v-if="createAny('users') && currentUserIsSuperAdmin()" fluid>
    <h1>Standaard instellingen</h1>
    <span>Hier kunnen enkele instellingen aangepast worden. Dit overschrijft de standaard instellingen zoals de portal is ingesteld. Sommige instellingen kunnen per gebruiker of opdrachtgever ingesteld worden. Die overschrijven nu de instellingen die hier gedaan zijn weer.</span>
    <hr />
    <h2>Contract instellingen</h2>
    <div class="form-row">
      <div class="col-3" v-if="settings.RegisterWorkhours">
        {{ $t("labels.workhours") }}
      </div>
      <div class="col-2" v-if="settings.RegisterWorkhours">
        <b-form-group>
          <b-form-radio v-model="workhours" value="no">{{ $t("labels.no") }}</b-form-radio>
          <b-form-radio v-model="workhours" value="yes">{{ $t("labels.yes") }}</b-form-radio>
        </b-form-group>
      </div>
      <div class="col-2" v-if="settings.SignWorkhours">
        {{ $t("labels.signworkhours") }}
      </div>
      <div class="col-2" v-if="settings.SignWorkhours">
        <b-form-group>
          <b-form-radio v-model="signworkhours" value="no">{{ $t("labels.no") }}</b-form-radio>
          <b-form-radio v-model="signworkhours" value="yes">{{ $t("labels.yes") }}</b-form-radio>
        </b-form-group>
      </div>
    </div>
    <div class="form-row">
      <div class="col-3">
        {{ $t("labels.notificationprojectstart") }}
      </div>
      <div class="col-2">
        <b-form-group>
          <b-form-radio v-model="startnotification" value="no">{{ $t("labels.no") }}</b-form-radio>
          <b-form-radio v-model="startnotification" value="yes">{{ $t("labels.yes") }}</b-form-radio>
        </b-form-group>
      </div>
      <div class="col-2">
        {{ $t("labels.notificationendworktime") }}
      </div>
      <div class="col-2">
        <b-form-group>
          <b-form-radio v-model="sendnotification" value="no">{{ $t("labels.no") }}</b-form-radio>
          <b-form-radio v-model="sendnotification" value="yes">{{ $t("labels.yes") }}</b-form-radio>
        </b-form-group>
      </div>
    </div>

    <div class="form-row">
      <div class="col-3">Tekst aanvang werktijd</div>
      <div class="col-2">
        <b-form-input type="text" class="form-control" v-model="startdatenote" />
      </div>
      <div class="col-3">Tekst einde werktijd</div>
      <div class="col-2">
        <b-form-input type="text" class="form-control" v-model="enddatenote" />
      </div>
    </div>
    <div class="form-row">
      <div class="col-3">
        <label v-bind:for="project_description">{{ $t("labels.description") }}</label>
      </div>
      <div class="col-7">
        <b-form-textarea class="form-control" v-model="project_description" />
      </div>
    </div>
    <hr />
    <h2>Project instellingen</h2>
    <div class="form-row">
      <div class="col-3">Starttijd</div>
      <div class="col-2">
        <b-form-input type="time" class="form-control" v-model="projectstarttime" />
      </div>
      <div class="col-3">Eindtijd</div>
      <div class="col-2">
        <b-form-input type="time" class="form-control" v-model="projectendtime" />
      </div>
    </div>
    <div class="form-row" v-if="settings.EnableHourPlanning || specialRights('URSchedule')">
      <div class="col-3">
        <label>{{ $t("meta.planningcolor") }}</label>
      </div>
      <div class="col">
        <input type="color" v-model="projectplanningscolor" />
      </div>
    </div>
    <hr />
    <h2>Factuur instellingen</h2>
    <div class="form-row">
      <div class="col">
        <b-form-checkbox v-model="showmanual" name="checkbox-1" value="1" unchecked-value="0">
          {{ $t("buttons.showmanual") }}
        </b-form-checkbox>
      </div>
    </div>
    <hr />
    <h2>Gebruikers documenten</h2>
    <b-form-checkbox v-model="usedocKVK" name="checkbox-1" value="1" unchecked-value="0"> {{ $t("labels.kvk") }}</b-form-checkbox>
    <b-form-checkbox v-model="usedocGPI" name="checkbox-1" value="1" unchecked-value="0"> {{ $t("labels.gpi") }}</b-form-checkbox>
    <b-form-checkbox v-model="usedocVCA" name="checkbox-1" value="1" unchecked-value="0"> {{ $t("labels.vca") }}</b-form-checkbox>
    <b-form-checkbox v-model="usedocID" name="checkbox-1" value="1" unchecked-value="0"> {{ $t("labels.identificationcard") }}</b-form-checkbox>
    <b-form-checkbox v-model="usedocAVB" name="checkbox-1" value="1" unchecked-value="0"> AVB</b-form-checkbox>
    <b-form-checkbox v-model="usedocRijbewijs" name="checkbox-1" value="1" unchecked-value="0"> {{ $t("labels.rijbewijs") }}</b-form-checkbox>
    <b-form-checkbox v-model="usedocZZPRagreement" name="checkbox-1" value="1" unchecked-value="0"> {{ $t("modules.enableAgreement") }}</b-form-checkbox>
    <b-form-checkbox v-model="usedocA1" name="checkbox-1" value="1" unchecked-value="0"> {{ $t("labels.a1") }}</b-form-checkbox>

    <!-- Save button -->
    <div @click="save_settings" class="btn btn-primary d-table ml-auto mt-5"><font-awesome-icon icon="save" /> {{ $t("buttons.savesettings") }}</div>
  </b-container>
</template>
<script>
import axios from "axios";
import { mapGetters, mapState } from "vuex";

export default {
  name: "projectzzper-planning",
  data() {
    return {
      projectstarttime: null,
      projectendtime: null,
      projectplanningscolor: null,
      startdate: null,
      startdatenote: "",
      enddate: null,
      enddatenote: "",
      planning_id: 0,
      showmanual: 1,
      project_reference_number: "",
      project_description: "",
      project_location: "",
      project_name: "",
      sign_id: null,
      copy_id: null,
      contact_id: null,
      contract_id: null,
      pointcontact_id: null,
      urencodering: null,
      urencoderingextended: null,
      invoiceperhourcode: null,
      hourcategory: 0,
      hourregistration: "app",
      inkoopfactuur: null,
      mailurenzzpr: "",
      mailurencontact: "",
      payment_zzprnl_zzpr: null,
      payment_client_zzpr: null,
      payment_client_zzprnl: null,
      tarief: null,
      verkooptarief: null,
      marge: null,
      betaalsysteem: null,
      btw_verlegd: null,
      found_planning_id: -1,
      kleur: "#ff0000",
      declaraties: [],
      extrainfoclient: "",
      extrainfozzpr: "",
      extrainfoinvoice: "",
      registerdeclarations: null,
      registernormalhours: "yes",
      contract_color: null,
      label1: "",
      label2: "",
      signworkhours: "",
      workhours: "",
      startnotification: "no",
      sendnotification: "no",
      starttime: null,
      endtime: null,
      usedocKVK: null,
      usedocGPI: null,
      usedocVCA: null,
      usedocID: null,
      usedocAVB: null,
      usedocRijbewijs: null,
      usedocZZPRagreement: null,
      usedocA1: null,
    };
  },

  mounted() {
    this.onMounted();
  },
  computed: {
    ...mapGetters(["zzpers", "createAny"]),
    ...mapState(["settings"]),
  },
  methods: {
    onMounted() {
      this.workhours = this.getOverWrite("workhours");
      this.signworkhours = this.getOverWrite("signworkhours");
      this.startdatenote = this.getOverWrite("startdatenote");
      this.enddatenote = this.getOverWrite("enddatenote");
      this.startnotification = this.getOverWrite("startnotification");
      this.sendnotification = this.getOverWrite("sendnotification");
      this.projectstarttime = this.getOverWrite("projectstarttime");
      this.projectendtime = this.getOverWrite("projectendtime");
      this.projectplanningscolor = this.getOverWrite("projectplanningscolor");
      this.project_description = this.getOverWrite("project_description");
      this.showmanual = this.getOverWrite("showmanual");
      this.usedocKVK = this.getOverWrite("usedocKVK");
      this.usedocGPI = this.getOverWrite("usedocGPI");
      this.usedocVCA = this.getOverWrite("usedocVCA");
      this.usedocID = this.getOverWrite("usedocID");
      this.usedocAVB = this.getOverWrite("usedocAVB");
      this.usedocRijbewijs = this.getOverWrite("usedocRijbewijs");
      this.usedocZZPRagreement = this.getOverWrite("usedocZZPRagreement");
      this.usedocA1 = this.getOverWrite("usedocA1");
      // this.inkoopfactuur = inkoopfactuur
    },

    save_settings() {
      try {
        let DefaultOverwrite = {};
        DefaultOverwrite.signworkhours = this.signworkhours;
        DefaultOverwrite.workhours = this.workhours;
        DefaultOverwrite.startdatenote = this.startdatenote;
        DefaultOverwrite.enddatenote = this.enddatenote;
        DefaultOverwrite.startnotification = this.startnotification;
        DefaultOverwrite.sendnotification = this.sendnotification;
        DefaultOverwrite.projectstarttime = this.projectstarttime;
        DefaultOverwrite.projectendtime = this.projectendtime;
        DefaultOverwrite.projectplanningscolor = this.projectplanningscolor;
        DefaultOverwrite.project_description = this.project_description;
        DefaultOverwrite.showmanual = this.showmanual;
        DefaultOverwrite.usedocKVK = this.usedocKVK;
        DefaultOverwrite.usedocGPI = this.usedocGPI;
        DefaultOverwrite.usedocVCA = this.usedocVCA;
        DefaultOverwrite.usedocID = this.usedocID;
        DefaultOverwrite.usedocAVB = this.usedocAVB;
        DefaultOverwrite.usedocRijbewijs = this.usedocRijbewijs;
        DefaultOverwrite.usedocZZPRagreement = this.usedocZZPRagreement;
        DefaultOverwrite.usedocA1 = this.usedocA1;
        axios
          .patch("/api/settings/", {
            DefaultOverwrite: JSON.stringify(DefaultOverwrite),
          })
          .then((response) => {
            console.log(response);
          });
      } catch (err) {
        console.log(err);
      }
    },
  },
  watch: {},
};
</script>
